import React from 'react';
import {style, classes} from './doppe-action-widget-text-box.st.css';
import {TextBox, reactCreateMemo } from "@wix/devzai-utils-react";

export const DoppeActionWidgetTextBox = reactCreateMemo(React.forwardRef(function DoppeActionWidgetTextBox (props: DoppeActionWidgetTextBox.Props, ref: React.Ref<TextBox> ) {
    const {
        hasError,

        className,
        ...htmlAttributes
    } = props;

    return (
        <TextBox
            {...htmlAttributes}
            className={style(classes.root, {hasError: hasError}, className)}
            ref={ref}
        />
    );
}));

export namespace DoppeActionWidgetTextBox {

    export interface Props extends TextBox.Props {
        hasError: boolean;
    }
}
